module.exports = __webpack_public_path__ + "media/images/icon-saved-queries-tile-a910ad241a8317083740ff3eb910f380.png";